module.exports = __webpack_public_path__ + "static/media/14.1aee5ba5.JPG";